import { i18n } from '@lingui/core';
// Needed for lingui 3.0.0-11
import { de, en } from 'make-plural/plurals';
i18n.loadLocaleData('en', { plurals: en });
i18n.loadLocaleData('de', { plurals: de });

export const defaultLocale = 'en';

export const locales = {
  en: 'English',
  de: 'Deutsch',
};

export async function load(locale) {
  if (!locale) return {};
  const catalog = await import(
    /* webpackMode: "lazy", webpackChunkName: "i18n-[request]" */
    `../../locales/${locale}.js`
  );
  const _catalog = catalog.__esModule ? catalog.default : catalog;

  i18n.load(locale, _catalog.messages);
  return catalog.messages;
}
